<template>
  <v-container v-if="sendFlg == false">
    <v-row class="first-row" justify="center">
      <h2>Contact</h2>
    </v-row>
    <v-row justify="center">
      <v-card
        color="white"
        width="512"
        height="100%"
      >
        <v-img
          height="35%"
          width="100%"
          :src="getContactImgPath()"
        >
        </v-img>
        <v-form>
          <v-container>
            <v-layout wrap>
              <v-flex class="input-area" xs12>
                <v-icon 
                  color="amber lighten-3"
                >
                  mdi-label
                </v-icon>
                <v-text-field
                  v-model='subject'
                  :disabled="isUpdating"
                  solo
                  label="Subject"
                ></v-text-field>
              </v-flex>
              <v-flex class="input-area" xs12>
                <v-icon 
                  color="amber lighten-3"
                >
                  mdi-card-account-details
                </v-icon>
                <v-text-field
                  v-model="name"
                  :disabled="isUpdating"
                  solo
                  label="Name"
                ></v-text-field>
              </v-flex>
              <!-- <v-flex class="input-area" xs12 sm6>
                <v-icon 
                  color="amber lighten-3"
                >
                  mdi-email
                </v-icon>
                <v-text-field
                  v-model="contact"
                  :disabled="isUpdating"
                  solo
                  label="Your email or sns account"
                ></v-text-field>
              </v-flex> -->
              <v-flex class="input-area" xs12>
                <v-icon 
                  color="amber lighten-3"
                >
                  mdi-note-text
                </v-icon>
                <v-textarea
                  solo
                  v-model="message"
                  label="Message"
                ></v-textarea>
              </v-flex>
              <v-row class="button-area">
                <v-spacer></v-spacer>
                <v-dialog
                  v-model="dialog"
                  persistent
                  max-width="290"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="yellow darken-2"
                      @click="getContactImgPath"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon left color="white">mdi-email-send-outline</v-icon>
                      <span class="button-text">Submit</span>
                    </v-btn>
                  </template>
                  <v-card
                    :loading="isUpdating"
                  >
                    <template slot="progress">
                      <v-progress-linear
                        color="amber lighten-1"
                        height="8"
                        indeterminate
                      ></v-progress-linear>
                    </template> 
                    <v-card-title class="headline">
                      Confirm
                    </v-card-title>
                    <v-card-text>送信しますか?</v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="yellow darken-3"
                        text
                        @click="dialog = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        color="yellow darken-3"
                        text
                        @click="okButton(subject, name, message)"
                      >
                        OK
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-row>
            </v-layout>
          </v-container>
        </v-form>
        <!-- <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="autoUpdate"
            :loading="isUpdating"
            color="yellow darken-2"
            depressed
            @click="isUpdating = true"
          >
            <v-icon left color="white">mdi-email-send-outline</v-icon>
            <span class="button-text">Submit</span>
          </v-btn>
        </v-card-actions> -->
      </v-card>
    </v-row>
  </v-container>
  <v-container v-else>
    <Thanks imgWidth=360 imgHeight=360 />
  </v-container>
</template>
<style scoped>
  /* 各ページの行頭のmarginを揃える */
  .first-row{
    margin-top: 20px;
  }
  h2{
    color: white;
    text-shadow: 1px 2px 3px #808080;
  }
  /* inputコンポーネントの上下パディングを除去 */
  .input-area{
    padding: 0px 12px 0px 12px;
  }
  /* ボタンテキストのカラー */
  .button-text{
    color: white;
    text-shadow: 1px 1px 0.5px #808080;  
  }
  .button-area{
    margin-top: -15px;
  }
</style>

<script>
  import Thanks from '../components/Thanks.vue'
  import router from '../router.js'
  // import ApiGateWay from '../scripts/apiGateWay.js'

  export default {
  components: { Thanks },
    name: 'Contact',
    data: () => ({
      contactImgPath: ['letter.jpeg', 'letter2.jpeg', 'letter3.jpeg'],
      imgBasePath: '/contact/',
      dialog: false,
      invalidParams: ['subject', 'name', 'message'],
      name: '',
      contact: '',
      message: '',
      subject: '',
      isUpdating: false ,
      sendFlg: false,
      axiosBase: null,
      axios: null,
    }),
    methods:{
      /**
       * 現在時間の3の倍数に対応する画像パスを返す
       */
      getContactImgPath(){
        // let max = 2;
        // let min = 0;
        var date = new Date()
        // console.log("current hour: " + date.getHours())
        // return this.imgBasePath + this.contactImgPath[Math.floor(Math.random() * (max + 1 - min)) + min]
        return this.imgBasePath + this.contactImgPath[(date.getHours() + 9) % this.contactImgPath.length]
      },

      /**
       * 送信ボタン押下後の処理
       */
      async okButton(subject, name, message){
        // 例)1.5秒スリープさせる ToDo: 後でリファクタ
        const _sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
        this.dialog = false
        const params = {
          'subject': subject,
          'name': name,
          'message': message
        }
        console.log(params)

        if(!await this.checkParams(params,this.invalidParams)){
          console.log('params invalid.')
          return false;
        }

        this.isUpdating = true // ローディングアニメの有効化
        if(await this.sendMessage(params)){
          this.isUpdating = false
          this.sendFlg = true;
          await _sleep(5000);
          router.push({ path: '/' }) 
        }else{
          console.log("failed to send message.")
        }
      },

      /**
       * 送信パラメータのnull、空文字チェック。
       * @params {params}: 辞書型 POSTパラメータ
       *         {invalidParams}: リスト POSTパラメータのヴァリデーション
       */
      async checkParams(params, invalidParams){
        for(let key in params){
          if(!params[key]){
            console.log('invalid params');
            return false
          }
          if(invalidParams.indexOf(params[key]) > -1){
            console.log('invalid param!')
            return false
          }
        }
        return true
      },
      /**
       * ApiGatewayへ接続。
       * @params {params}: 辞書型 POSTパラメータ
       */
      async sendMessage(params){
        let sendingIsOk = false;
        console.log(params)
        await this.axios.post(
          '/contact',
          params,
        ).then(function(response) {
            console.log(response.data);
            sendingIsOk = true
        }).catch(function(error) {
            console.log('ERROR!! occurred.')
            console.log(error)
        });
        return sendingIsOk
      }
    },
    beforeMount(){
      this.axiosBase = require('axios');
      this.axios = this.axiosBase.create({
        baseURL: 'https://zi1fuo4xgi.execute-api.ap-northeast-1.amazonaws.com/myPotfolioSIte',
        responseType: 'json'
      })
    }
  }
</script>
